module.exports = __webpack_public_path__ + "img/manchestore-compare-slider.e7b7d059.png";